import { useState } from 'react';
import Icon from '../../../components/AppIcon';


const MeetingCard = ({ meeting, onSelect, isSelected, onEdit, onDelete, userRole }) => {
  const [showActions, setShowActions] = useState(false);

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400';
      case 'draft':
        return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400';
      case 'scheduled':
        return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400';
      default:
        return 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const canEdit = userRole === 'Admin' || userRole === 'Ops' || meeting?.organizer === 'Current User';

  return (
    <div
      className={`relative p-4 rounded-lg border transition-all duration-200 cursor-pointer hover:shadow-md ${
        isSelected
          ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/50'
      }`}
      onClick={() => onSelect(meeting)}
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Calendar" size={16} className="text-primary flex-shrink-0" />
            <h3 className="font-semibold text-foreground truncate">{meeting?.title}</h3>
          </div>
          
          <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
            <Icon name="Clock" size={14} />
            <span>{formatDate(meeting?.date)}</span>
            <span className="text-xs">•</span>
            <span>{meeting?.duration}</span>
          </div>

          <div className="flex items-center gap-2 mb-3">
            <span className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium ${getStatusColor(meeting?.status)}`}>
              {meeting?.status?.charAt(0)?.toUpperCase() + meeting?.status?.slice(1)}
            </span>
            {meeting?.actionItemsCount > 0 && (
              <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400">
                <Icon name="CheckSquare" size={12} />
                {meeting?.actionItemsCount} Actions
              </span>
            )}
          </div>

          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Icon name="Users" size={12} />
            <span>{meeting?.attendeesCount} attendees</span>
          </div>
        </div>

        {showActions && canEdit && (
          <div className="flex items-center gap-1 absolute top-2 right-2 bg-card border border-border rounded-md shadow-lg p-1">
            <button
              onClick={(e) => {
                e?.stopPropagation();
                onEdit(meeting);
              }}
              className="p-1.5 rounded hover:bg-accent/10 text-muted-foreground hover:text-accent transition-colors"
              aria-label="Edit meeting"
            >
              <Icon name="Edit2" size={14} />
            </button>
            <button
              onClick={(e) => {
                e?.stopPropagation();
                onDelete(meeting);
              }}
              className="p-1.5 rounded hover:bg-destructive/10 text-muted-foreground hover:text-destructive transition-colors"
              aria-label="Delete meeting"
            >
              <Icon name="Trash2" size={14} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MeetingCard;